@import "../../less/variables.less";

.loginCard {
  display: flex;
  padding: var(--dds-spacing-medium-20) 24px;
  margin-bottom: var(--dds-spacing-small-12);
  align-items: center;
  align-self: stretch;
  gap: var(--dds-spacing-medium-20);
  border: none;
  background: var(--dds-card-bg-accent);
  justify-content: space-between;
  max-height: 86px;
  width: 100%;
  border-radius: var(--dds-radius-medium);

  @media @dds-breakpoint-phone-small {
    padding: var(--dds-spacing-small-8);
    gap: var(--dds-spacing-small-8);
  }
}

.loginCard:hover {
  background: var(--dds-card-bg-secondary);
  cursor: pointer;
}

.textCard {
  display: flex;
  align-items: center;
  gap: 20px;
  color: var(--dds-sort-kaffe);
  text-align: left;

  @media @dds-breakpoint-phone-small {
    gap: var(--dds-spacing-small-8);
  }
}

.textCard li {
  height: 55px;
  border-left: solid 1px #e6e6e6;
  display: inline;
}

.textCard h3 {
  margin: 0;
  text-align: start;
}

.chevron {
  max-width: 20px;
  max-height: 20px;
  flex-shrink: 0;
}

.loginCardIcon {
  max-width: 64px;
}
